export default __webpack_public_path__ + "static/media/masthead.9a543629.webp";